var _path, _path2, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountSymbolWithNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9996 8.21143C13.693 8.21143 15.066 9.57268 15.066 11.2523C15.066 12.9318 13.693 14.2931 11.9996 14.2931C10.3059 14.2931 8.9332 12.9318 8.9332 11.2523C8.9332 9.57268 10.3059 8.21143 11.9996 8.21143Z",
    stroke: "#68778A",
    strokeWidth: 1.93069,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3852 16.1038H9.61524C8.2524 16.1038 6.20813 18.5787 6.20813 18.8067V20.7089C6.20813 20.9369 6.42423 21.1218 6.6908 21.1218H12.0002H17.3096C17.5762 21.1218 17.7923 20.9369 17.7923 20.7089V18.8067C17.7923 18.5787 15.7481 16.1038 14.3852 16.1038Z",
    stroke: "#68778A",
    strokeWidth: 1.93069,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 15.5,
    r: 11,
    stroke: "#68778A",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 6.5,
    r: 5,
    fill: "#FC3D86",
    stroke: "#F6F9FC",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountSymbolWithNotification);
export default __webpack_public_path__ + "static/media/accountSymbolWithNotification.be28ae59cc52f0a5da6308f0f12060c0.svg";
export { ForwardRef as ReactComponent };